import { render, staticRenderFns } from "./OrganizationNavListGroup.vue?vue&type=template&id=2a70e354&scoped=true&"
import script from "./OrganizationNavListGroup.vue?vue&type=script&lang=js&"
export * from "./OrganizationNavListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70e354",
  null
  
)

export default component.exports